const verticalSelectors = document.querySelectorAll( '.js-vertical-selector' );

// Add a listener to each vertical selector to catch click events
verticalSelectors.forEach( selector => {
    selector.addEventListener( 'click', () => {
        // Show clicked selector as active
        verticalSelectors.forEach( selector => selector.classList.remove( 'active' ) );
        selector.classList.add( 'active' );
    });
});
